import React, { useEffect, useState } from "react";
import Button from "../../components/atoms/Button";
import InputText from "../../components/atoms/InputText";
import styles from "./styles.module.css";
import RightArrow from "../../images/arrow-right.png";
import { useNavigate,useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAuthData } from "../../redux/slice/userData";
// import { process.env.REACT_APP_DASHBOARD_URL } from "../../utils";
import { useSessionStorage } from "../../hooks/useSessionStorage";
import { useTimer } from "react-timer-hook";

const Login: React.FC = () => {
  const [state, setState] = useState<"PHONE" | "OTP">("PHONE");
  const [number, setNumber] = useState<string>("");
  const [otp, setOtp] = useState<string>("");
  const dispatch = useDispatch();
  const location = useLocation();
  const { seconds, isRunning, restart } = useTimer({
    expiryTimestamp: new Date(new Date().getTime() + 30 * 1000),
    autoStart: false,
  });

  const navigate = useNavigate();
  const [sanctionLetterUrl, setSanctionLetterUrl] = useState<string>("");
  const [showSanctionLetter, setShowSanctionLetter] = useState(false);
  const [sanctionDataLoading, setSanctionDataLoading] = useState(false);
  const [authToken, setAuthToken] = useSessionStorage("feemonk_data", "");

  useEffect(() => {
    const authenticate = (auth_token: string) => {
      var myHeaders = new Headers();

      myHeaders.append("Authorization", `Bearer ${auth_token}`);

      var requestOptions: RequestInit = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${process.env.REACT_APP_DASHBOARD_URL}/integrations-login/auth`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result?.data) {
            if(result?.data?.digilockerStatus === 3){
              navigate("/mandate")
            }
            else if (result?.data?.enachStatus === 4) {
              navigate("/thank-you");
            }else{
              dispatch(setAuthData(result?.data));
            }
          }
        })
        .catch((error) => console.log("error", error));
    };

    if (authToken && authToken.value) {
      authenticate(authToken.value);
    }
  }, [navigate, dispatch, authToken]);

  const sendOtp = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      mobile: number,
    });

    var requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_DASHBOARD_URL}/integrations-login/otp`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.error) {
          alert(result.message[0]);
        } else if (result.message === "Successful") {
          setState("OTP");
        }
        // console.log(result);
      })
      .catch((error) => console.log("error", error));
  };

  const verifyOtp = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      mobile: number,
      otp: otp,
      applicationId:location?.state?.applicationId ? location?.state?.applicationId:sessionStorage.getItem("applicationId"),
      userId:location?.state?.userId ? location?.state?.userId:sessionStorage.getItem("userId")
    });

    var requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_DASHBOARD_URL}/integrations-login/verify-otp`, requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        // console.log(result);
        // console.log(result.message);

        if (result.message === "Invalid OTP") {
          alert("Invalid OTP");
        } else if (result.message === "Successful") {
          // await sessionStorage.setItem(
          //   "feemonk_data",
          //   JSON.stringify({
          //     auth_token: result.data,
          //     mobile_number: number,
          //   })
          // );

          setAuthToken({
            value: result.data,
            mob: number,
          });

          authenticate(result.data);
          getSanctionDetails(result.data)
        }
      })
      .catch((error) => console.log("error", error));
  };

  const authenticate = (auth_token: string) => {
    var myHeaders = new Headers();

    myHeaders.append("Authorization", `Bearer ${authToken && authToken.value}`);

    var requestOptions: RequestInit = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_DASHBOARD_URL}/integrations-login/auth`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log("IMP", result);

        if (result?.message === "Successful") {
          // console.log(result?.data.userId);
          dispatch(setAuthData(result?.data));
        }
      })
      .catch((error) => console.log("error", error));
  };

  const getUrlContent = async (s3EndUrl: string) => {
    const authResponse = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/login/auth`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ memberId: "9072e019-e159-4bdc-812a-bb3f255f4af0" }),
    });
    const authData = await authResponse.json();
    const urlToken = authData?.data;
    if (!urlToken) {
      throw new Error("Authentication token not received");
    }
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${urlToken}`);
    const res: any = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/file/url-content?path=${s3EndUrl}`, {
      method: "GET",
      headers: myHeaders,
    });
    const response = await res.json();
    return response?.data;
  }

  const getSanctionDetails = async (token: string) => {
    setSanctionDataLoading(true)
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    try {
      const res = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/integrations/sanction-details`,
         {
          method: "GET",
          headers: myHeaders,
          redirect: "follow",
        }
      )
      const response = await res.json()
      const s3EndUrl = response?.data?.sanctionLetterUrl?.split("amazonaws.com/")[1]
      const url = await getUrlContent(s3EndUrl)
      setSanctionLetterUrl(url)
      setShowSanctionLetter(true)
    } catch (error:any) {
      alert(`Failed generate Sanction letter, Please contact support. ${error?.message}`);
    } finally {
      setSanctionDataLoading(false);
    }
  }
  return (
    <div className={styles.main}>
      <div className={styles.container}>
        {/* <h1>00:{seconds}</h1> */}
        {state === "OTP" ? (
          seconds > 0 ? (
            <h1>00:{seconds}</h1>
          ) : (
            <h1>Welcome</h1>
          )
        ) : (
          <h1>Welcome</h1>
        )}
        {state === "OTP" ? (
          <p>Type The Verification Code We've Sent You</p>
        ) : (
          <p>Please confirm your country code and enter your phone number</p>
        )}

        {state === "OTP" ? (
          <div className={styles.inputField}>
            <InputText
              placeholder="OTP"
              type="number"
              value={otp}
              changeHandler={(e) => setOtp(e.target.value)}
            />
          </div>
        ) : (
          <div className={styles.inputField}>
            <InputText
              placeholder="Phone Number"
              type="number"
              value={number}
              changeHandler={(e) => setNumber(e.target.value)}
            />
          </div>
        )}
        {state === "OTP" ? (
          <Button
            onPress={() => {
              verifyOtp();
            }}
            text="SUBMIT"
            imageRight={RightArrow}
          />
        ) : (
          <Button
            onPress={() => {
              sendOtp();
              restart(new Date(new Date().getTime() + 30 * 1000));
            }}
            text="Login"
            imageRight={RightArrow}
          />
        )}
        {state === "OTP" && seconds < 1 && !isRunning && (
          <Button
            onPress={() => {
              sendOtp();
              restart(new Date(new Date().getTime() + 30 * 1000));
            }}
            text="Resend OTP"
          />
        )}
      </div>
    {showSanctionLetter && sanctionLetterUrl && (
      <div className={styles.overlay}>
        <div className={styles.iframeContainer}>
          <h3>Sanction letter</h3>
          <iframe
            onLoad={() => setSanctionDataLoading(false)}
            src={`https://docs.google.com/gview?url=${encodeURIComponent(
              sanctionLetterUrl
            )}&embedded=true`}
            className={styles.iframe}
            title="Sanction Letter"
          />
            <Button
            text="Proceed" 
            disabled={sanctionDataLoading}
            onPress={() => {
              setShowSanctionLetter(false);
              navigate("/mandate");
            }}
            
          />
        </div>
      </div>
    )}

    </div>
  );
};

export default Login;
